import { create } from "zustand";

type State = {
  aeoBrainInFlight: number;
  beginAeoBrainGeneration: () => void;
  endAeoBrainGeneration: () => void;
};

export const useAeoBrainGenerationInFlightStore = create<State>((set) => ({
  aeoBrainInFlight: 0,
  beginAeoBrainGeneration: () =>
    set((state) => ({ aeoBrainInFlight: state.aeoBrainInFlight + 1 })),
  endAeoBrainGeneration: () =>
    set((state) => ({ aeoBrainInFlight: Math.max(0, state.aeoBrainInFlight - 1) })),
}));
